import { strings } from "./i18n";
import { stipplUrl } from "./links";
import type { PartnerMapContent } from "./types";
import styles from "./PartnerMap.module.scss";

/** The small print at the foot of both tabs. The photo credits are not here: those that are owed sit behind the map's (i). */
const Disclaimer = ({ content }: { content: PartnerMapContent }) => {
	const t = strings(content.lang);
	return (
		<p className={styles.disc}>
			{t.mapMadeWith}{" "}
			<a href={stipplUrl(content)} target="_blank" rel="noopener">
				Stippl
			</a>
			{t.tripPlanner}
			{content.partner.name}
			{`. ${content.smallPrint ?? t.hostelSmallPrint}`}
		</p>
	);
};

export default Disclaimer;
